const tapStoryDataRequestAction = () => {
    return (dispatch, getState, { componentDataEngine }) => {
        const state = getState();
        const {
            gumbo: {
                gamePk
            },
            config: {
                language = 'en'
            }
        } = state;

        return componentDataEngine
            .fetchAndStore('schedule', { gamePk, language })
            .catch((tapStoryError) =>
                console.error(tapStoryError)
            );
    };
};

export default tapStoryDataRequestAction;
